import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from "react-dom";

import { diaPorNumero, traducirPagina, obtenerUsuario, MSGOK, MSGERROR, nuevoFormatoFechaCliente, obtenerToken } from "../../librerias/funciones";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { GetSertecMarketingSociosEnAPI, SetSertecMarketingSociosEnAPI } from "../../action/actionCreatorsRequests";
import { Select } from 'antd';
import {
    PlusOutlined
} from '@ant-design/icons';
import  FichaMarketing  from "./FichaMarketing";
const { Option } = Select;



const PageMarketing = ({ usuario }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [reglasAlmacenes, setReglasAlmacenes] = React.useState([]);
    
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [abrirFichaMarketing, setAbrirFichaMarketing] = React.useState(false);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [usuarioSeleccionado, setUusuarioSeleccionado] = React.useState({});


    const GetSertecMarketingSocios = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, NOMBRE) => {
        setReglasAlmacenes([])

        GetSertecMarketingSociosEnAPI(ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, NOMBRE).then((reglas) => {
            if (reglas !== undefined) {
                if (reglas.REGISTROS !== null && reglas.REGISTROS.length > 0) {
                    setReglasAlmacenes(reglas.REGISTROS)
                } else {
                    setReglasAlmacenes(null)
                }
            }

        })
    }


    const DarDeBajaUsuario = (payLoadLocal) => {
        SetSertecMarketingSociosEnAPI(2, payLoadLocal).then(usuario => {
            if (usuario !== undefined) {
                if (usuario.OK) {
                    MSGOK(traducirPagina("Msg_eliminar_anuncio"))

                    GetSertecMarketingSocios(1, "A", socioSeleccionado, "", "")

                }
            }
        })
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            console.log("ref.current.clientHeight", ref.current.clientHeight)
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)


            GetSertecMarketingSocios(1, "A", accesoLicencia.SOCIOS[0].ID_SOCIO, "", "")
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - MARKETING`}
        </>,
        document.getElementById("tituloMenu")
    );

    return (
        <>
            <div>
                <div className="menu_mantenimiento" ref={ref}>

                    <div className="mantenimiento_item1" style={{ gap: '10px' }}>

                        <div>
                            {sociosLocal !== null ?
                                <Select
                                    showSearch
                                    allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                                    defaultValue={obtenerUsuario() !== null ? obtenerUsuario().SOCIOS[0].ID_SOCIO : ""}
                                    size={"large"}
                                    placeholder={traducirPagina("Seleccione_socio")}
                                    style={{ width: "400px", textAlign: 'left' }}
                                    optionFilterProp="children"
                                    onChange={(e) => {
                                        if (e === undefined || e === null) {
                                            //setLicencias(null)
                                        } else {
                                            setSocioSeleccionado(parseInt(e));
                                            GetSertecMarketingSocios(1, "A", e, "", "")
                                            //licenciasSertec(1, "A", e);

                                        }
                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {sociosLocal.length > 0 ?
                                        sociosLocal.map((socio) =>
                                            <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                        )
                                        :
                                        null
                                    }
                                </Select>
                                :
                                <div style={{ textAlign: 'center' }}>
                                    <h4>{traducirPagina("Info_error_socio")}</h4>
                                </div>
                            }
                        </div>
                    </div>


                    <div className="btn_Publiciadad" style={{ display: 'flex', alignItems: 'center' }} onClick={(e) => { setAbrirFichaMarketing(true); setUusuarioSeleccionado({}) }}>
                        <PlusOutlined style={{ fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', cursor: 'pointer' }} />
                        {traducirPagina("Nueva_campania")}
                    </div>



                </div>
            </div>

            <div className="margen_tabla">
                {reglasAlmacenes === null ?
                    <div style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )`, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div>
                    :
                    reglasAlmacenes.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ width: '60px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("ID")}  </th>
                                        <th style={{ width: '270px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("Nombre")} </th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("Nombre_alternativo")} </th>

                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Dia_fecha_unica")} </th>
                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Fecha_unica")}</th>

                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Repeticion")} </th>
                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Dia_creacion")}</th>

                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Entre_dos_fechas")} </th>
                                        <th style={{ width: '300px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}> {traducirPagina("Fechas")}</th>

                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {traducirPagina("Observaciones")}</th>



                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} > </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reglasAlmacenes.map((regla) =>
                                        <tr key={regla.ID} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.ID}>{regla.ID}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} title={regla.NOMBRE}>{regla.NOMBRE}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{regla.NOMBRE_ALTERNATIVO}</td>


                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.DIA_FECHA_UNICA ? traducirPagina("SI") : traducirPagina("NO")}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{nuevoFormatoFechaCliente(regla.FECHA_UNICA)}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.REPETICION ? traducirPagina("SI") : traducirPagina("NO")}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{diaPorNumero(regla.DIA_REPETICION)}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.ENTRE_DOS_FECHAS ? traducirPagina("SI") : traducirPagina("NO")}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{regla.ENTRE_DOS_FECHAS ? `${regla.FECHA_DESDE} : ${regla.FECHA_HASTA}` : ""}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{regla.OBSERVACIONES}</td>


                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                <div className="flex-container-Grow-Simple">
                                                    <div style={{ margin: '0px 2px' }}>

                                                        <button title={"Modificar"} onClick={() => {
                                                            setUusuarioSeleccionado(regla);
                                                            //setAbrirFichaMostrador(true);
                                                            setAbrirFichaMarketing(true)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>
                                                    </div>



                                                    <div style={{ margin: '0px 2px' }} >
                                                        <button title={"Dar de baja"} onClick={() => {
                                                            DarDeBajaUsuario(regla)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>

            {abrirFichaMarketing && (
                <FichaMarketing
                    title={traducirPagina("Publicar_anuncio").toUpperCase()}
                    ABRIR_FICHA={abrirFichaMarketing}
                    CERRAR_FICHA={setAbrirFichaMarketing}
                    ID_SOCIO={socioSeleccionado}


                    ACTUALIZAR_REGLAS={GetSertecMarketingSocios}
                    SELECCIONADO={usuarioSeleccionado}
                    MODIFICAR_SELECCIONADO={setUusuarioSeleccionado}
                >

                </FichaMarketing>
            )
            }
        </>
    );
}



PageMarketing.propTypes = {
    EVENTO_MENU: PropTypes.func
};


const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        listaTree: state.listaTree,
        configApp: state.configApp,
        activeItemReferencia: state.activeItemReferencia,
        usuario: state.usuario
    };
}

export default connect(mapStateToProps)(PageMarketing);




